<template>
  <section class="ui-game-over" :class="{ 'ui-game-over--app' : $inApp }">
    <span class="ui-game-over__bg" />

    <div class="ui-game-over__banner">
      <img src="/assets/svg/cloud.svg" alt="cloud game over">
      <p>GAME OVER</p>
    </div>

    <div class="ui-game-over__content" :class="{ 'ui-game-over__content--app' : $inApp }">
      <GameScore class="ui-game-over__score" />

      <ButtonShare class="content__share" v-if="$inApp" />

      <TableScore
        class="content__table"
        v-if="$inApp && $isLogged"
      />

      <ButtonRounded
        class="content__button"
        :content="$translate('start')"
        action="playAgain"
      />
    </div>

  </section>
</template>

<script>
import GameScore from '@/components/GameScore.vue';
import ButtonShare from '@/components/ButtonShare.vue';
import ButtonRounded from '@/components/ButtonRounded.vue';
import TableScore from '@/components/TableScore.vue';

export default {
  name: 'UIendGame',

  components: {
    GameScore,
    ButtonShare,
    ButtonRounded,
    TableScore,
  },

  mounted() {
    if (this.$inApp && this.$isLogged) {
      this.$store.dispatch('saveUserScore', this.$store.state.score);
    }
  },
};
</script>

<style lang="scss" scoped>
.ui-game-over {
  text-align: center;
  color: $color-yellow;

  &__bg {
    @include full();

    background-color: rgba($color-green, 0.9);
  }

  &,
  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column nowrap;
  }

  &__banner {
    position: absolute;
    top: 5.5vh;
    width: 11vw;
    min-width: 150px;
    left: 50%;

    color: $color-white;

    img {
      display: block;
      position: relative;
      width: 100%;
    }

    p {
      position: absolute;
      bottom: 37%;
      left: 0;
      width: 100%;

      text-align: center;
      font-weight: bold;
      @extend %font-score;
    }
  }

  &__content {
    position: relative;
    height: 100%;
    padding-top: 24vh;

    @include mq($until: mobileL) {
      padding-top: 20vh;
    }

    .content__share,
    .content__table {
      position: relative;
      margin-top: 3vh;

      @include mq($until: mobileL) {
        margin-top: 5vh;
      }
    }

    .content__button {
      position: relative;
      margin-top: 8vh;

      @include mq($until: mobileL) {
        margin-top: 15vh;
      }
    }

    &.ui-game-over__content--app .content__button {
      margin-top: 5vh;
    }
  }

  &__cookie {
    position: absolute;
    bottom: 20px;
    width: 100%;
    color: $color-white;
  }
}
</style>
